const CTA_API_KEY = 'Lxbb8MnukjaCLSGuYMRJSWnY6';
const CTA_TRAIN_API_KEY = 'b758a9f1ae7e4fb494f4cd613bf6c7ba';

export const ctaBusTrackerBasePath = () => {
    return process.env.NODE_ENV === 'development'
        ? 'http://www.ctabustracker.com/bustime/api/v2/'
        : '/ctabustracker/';
};

export const lapiBasePath = () => {
    return process.env.NODE_ENV === 'development'
        ? 'http://lapi.transitchicago.com/api/1.0/'
        : '/lapi/';
};

export const getRoutes= () => {
    return `${ctaBusTrackerBasePath()}getroutes?key=${CTA_API_KEY}&format=json`;
};

export const getDirections = (route) => {
    return `${ctaBusTrackerBasePath()}getdirections?key=${CTA_API_KEY}&rt=${route}&format=json`;
};

export const getStops = (route, destination) => {
    return `${ctaBusTrackerBasePath()}getstops?key=${CTA_API_KEY}&rt=${route}&dir=${destination}&format=json`;
};

export const getBusStopPredictions = (busStopId) => {
    return `${ctaBusTrackerBasePath()}getpredictions?key=${CTA_API_KEY}&stpid=${busStopId}&format=json`;
};

// uses socrata
export const CTA_L_STOP_BASE_URL = 'https://data.cityofchicago.org/resource/8pix-ypme.json?';

export const getLTrainStations = (colorKey) => {
    return `${CTA_L_STOP_BASE_URL}${colorKey}=true`; 
};

export const getCtaTrainStationArrivals = (stopId) => {
    return `${lapiBasePath()}ttarrivals.aspx?key=${CTA_TRAIN_API_KEY}&stpid=${stopId}&outputType=JSON`;
};

